<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "../stores/auth";

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const navItems = [
  { to: "/dashboard", index: "01", zh: "工作台", en: "Dashboard" },
  { to: "/appointments", index: "02", zh: "预约管理", en: "Appointments" },
  { to: "/services", index: "03", zh: "服务项目", en: "Service Content" },
  { to: "/company", index: "04", zh: "公司资料", en: "Company Profile" },
  { to: "/system", index: "05", zh: "系统管理", en: "System & Security" }
];

const currentTitle = computed(() => navItems.find((item) => route.path.startsWith(item.to)) || navItems[0]);

function logout() {
  auth.logout();
  void router.replace("/login");
}
</script>

<template>
  <div class="admin-shell">
    <aside class="side-rail">
      <div class="rail-brand">
        <div class="rail-wordmark">YMA</div>
        <div><span>TECHNOLOGY &amp; SERVICE</span><small>INDUSTRIAL SERVICE CONSOLE</small></div>
      </div>

      <nav class="rail-nav" aria-label="后台导航">
        <router-link v-for="item in navItems" :key="item.to" :to="item.to" class="rail-link">
          <span class="rail-index">{{ item.index }}</span>
          <span class="rail-copy"><b>{{ item.zh }}</b><small>{{ item.en }}</small></span>
          <span class="rail-arrow">→</span>
        </router-link>
      </nav>

      <div class="rail-status">
        <div class="status-pulse"></div>
        <div><b>服务系统运行中</b><small>SYSTEM ONLINE</small></div>
      </div>

      <div class="rail-user">
        <div class="user-monogram">{{ auth.identity?.displayName?.slice(0, 1) || 'Y' }}</div>
        <div><b>{{ auth.identity?.displayName || 'YMA Admin' }}</b><small>{{ auth.roleLabel(auth.identity?.role) }}</small></div>
        <button type="button" @click="logout" title="退出登录">↗</button>
      </div>
    </aside>

    <main class="admin-main">
      <header class="top-console">
        <div>
          <span class="console-kicker">YMA / SERVICE OPERATIONS</span>
          <h1>{{ currentTitle.zh }}</h1>
          <p>{{ currentTitle.en }}</p>
        </div>
        <div class="console-meta">
          <div><span>服务区域</span><b>亚洲 · ASIA</b></div>
          <div><span>营业时间</span><b>08:00—18:00</b></div>
        </div>
      </header>
      <section class="admin-view"><router-view /></section>
    </main>
  </div>
</template>
